import AboutUs from "@/components/enfinity/AboutUs";
import CreatorsLifeCycle from "@/components/enfinity/CreatorsLifeCycle";
import CTA from "@/components/enfinity/CTA";
import FAQSection from "@/components/enfinity/Faq";
import Footer from "@/components/enfinity/Footer";
import Header from "@/components/enfinity/Header";
import OurServices from "@/components/enfinity/OurServices";
import SectionUnderServices from "@/components/enfinity/SectionUnderServices";
import PowerfulPartnership from "@/components/enfinity/PowerfulPartnership";
import RevenueCalculator from "@/components/enfinity/RevenueCalculator";
import StartEarning from "@/components/enfinity/StartEarning";
import SuccessStories from "@/components/enfinity/SuccessStories";
import { useEffect } from "react";

export default function EnfinityMain() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const mainFaqs = [
    {
      question: "Does creating an Enfinity Account cost me money?",
      answer:
        "No, it's completely free. Once signed up, you can enable or disable features like early YouTube payments and daily payouts. Any applicable fees are deducted from future earnings, meaning no invoices, no hidden charges, no entering a credit card. You only share a portion of your next month's incoming payments with us when you actually use a service, and everything is transparent and pre-agreed upon by you.",
    },
    {
      question: "How fast are payouts processed?",
      answer:
        "Payouts are processed daily for eligible services. Early Pay allows you to access funds even sooner.",
    },
    {
      question: "Can I disable services after enabling them?",
      answer:
        "Yes, you have full control. Services can be enabled or disabled anytime from your dashboard.",
    },
    {
      question: "What support channels are available?",
      answer:
        "You can reach us via Telegram, WhatsApp, or email. Our support team is available 24/7.",
    },
  ];

  return (
    <div className="bg-[#111111]">
      <Header />

      <CreatorsLifeCycle />

      <RevenueCalculator />

      <AboutUs />

      <OurServices />

      <SectionUnderServices />

      <PowerfulPartnership />

      <StartEarning />

      <SuccessStories />

      <CTA />

      <div className="min-h-[900px] bg-white lg:pb-36 xxs:pb-60">
        <FAQSection faqs={mainFaqs} />
      </div>

      <Footer />
    </div>
  );
}
